/* eslint-disable max-len */
module.exports = {
  map: {
    primaryTileLayerUrl:
      'https://server.arcgisonline.com/ArcGIS/rest/services/Canvas/World_Light_Gray_Base/MapServer/tile/{z}/{y}/{x}',
    primaryTileLayerAttribution: 'Tiles &copy; Esri &mdash; Esri, DeLorme, NAVTEQ',
    satelliteTileLayerUrl:
      'https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}',
    satelliteTileLayerAttribution:
      'Tiles &copy; Esri &mdash; Source: Esri, i-cubed, USDA, USGS, AEX, GeoEye, Getmapping, Aerogrid, IGN, IGP, UPR-EGP, and the GIS User Community',
    enableAttribution: true,
    defaultZoomLevel: 12,
    maxZoomLevel: 16,
    minZoomLevel: 10,
    defaultCenter: [40.729, -73.95],
    maxBoundsWorld: [
      [40.4774, -74.2591], // Southwest corner
      [41.0159, -73.7004], // Northeast corner
    ],
    maxClusterDistanceInKm: 0.875,
  },
  geolocation: {
    // https://developer.mozilla.org/en-US/docs/Web/API/PositionOptions
    enableHighAccuracy: true,
    timeout: 7500,
  },
  geosearch: {
    // https://github.com/smeijer/leaflet-geosearch#geosearchcontrol
    showMarker: true,
    showPopup: false,
    animateZoom: false,
    autoClose: false,
    keepResult: false,
    updateMap: true,
    popupFormat: ({ result }) => `${result.label}`,
    resultFormat: ({ result }) => `${result.label}`,
    autoComplete: true,
    autoCompleteDelay: 250,
    zoomLevel: 5,
    notFoundMessage: 'No hoops found nearby',
    searchLabel: 'Search New York Hoops',
    style: 'bar',
  },
  maxVideoDurationSeconds: 30,
  maxVideoSizeInMb: 200,
};
